import { getAPCAContrast } from "./getAPCAContrast";

// -108 is the max value for the APCA contrast ratio (for light on dark)
const isColorLowContrast = (hexaColor: string) => {
  return Math.abs(getAPCAContrast(hexaColor, "#FFFFFF")) < 108 / 2;
};

export { isColorLowContrast };
